import React, { useState } from "react";
import { Form, Table } from "react-bootstrap";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaCheckCircle } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";

const LabTable = (props) => {
  const [show, setShow] = useState(false);
  const [Input, setInput] = useState({
    medicine: "",
    dosage: "",
    duration: "",
    instructions: "",
  });
  const [response, setResponse] = useState(
    props.labTestList ? props.labTestList : []
  );

  const handleOnInputChange = (e) => {
    const nam = e.target.name;
    const val = e.target.value;
    setInput((prevState) => {
      return { ...prevState, [nam]: val };
    });
  };

  const handleAddNewTest = () => {
    if (show) {
      if (
        Input.medicine.trim() === "" ||
        Input.dosage.trim() === "" ||
        Input.duration.trim() === "" ||
        Input.instructions.trim() === ""
      ) {
        console.log("Please fill in all the fields!");
        return;
      } else {
        console.log("The values", Input);
        props.setLabTestList((prevState) => {
          Input.id = uuidv4();
          return [...prevState, Input];
        });

        setResponse((prevState) => {
          Input.id = uuidv4();
          return [...prevState, Input];
        });
        setInput({
          medicine: "",
          dosage: "",
          duration: "",
          instructions: "",
        });
        setShow(true);
      }
    } else {
      setShow(true);
    }
  };

  const deleteEntry = (index) => {
    console.log("the index", index);
    if (index > -1) {
      setResponse((prevState) => {
        let arr = prevState;
        let removed = [];
        arr.forEach((element, i) => {
          if (i !== index) {
            removed.push(element);
          }
        });
        console.log("The arr", removed);
        return removed;
      });
    }
  };
  const language = useSelector((state) => state.language);
  return (
    <div className="pres-table">
      <div className="medicines-heading">{language.lang.medical_orders}</div>
      <div>
        <button className="med-btn">{language.lang.past_orders}</button>
        <button className="btn-add" onClick={handleAddNewTest}>
        {language.lang["add-new"]} +
        </button>
      </div>
      <Table responsive>
        <thead>
          <tr>
            <th scope="col">{language.lang.no}</th>
            <th scope="col" style={{whiteSpace: "nowrap"}}>{language.lang["report-type"]}</th>
            <th scope="col">{language.lang.date}</th>
            <th scope="col">{language.lang.action}</th>
            <th scope="col">{language.lang.instructions}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {response.map((element, index) => {
            return (
              <tr key={uuidv4()}>
                <td className="serial-num">{index + 1}</td>
                <td>
                  <Form.Control
                    type="text"
                    className="shadow-none"
                    value={element.medicine}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    className="shadow-none color-dark"
                    value={element.dosage}
                    style={{textAlign: 'center',minWidth:'140px'}}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    className="shadow-none color-dark"
                    value={element.duration}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    className="shadow-none"
                    value={element.instructions}
                  />
                </td>
                <td>
                  <RiDeleteBin6Line
                    size={20}
                    className="del-icon"
                    onClick={() => deleteEntry(index)}
                  />
                </td>
              </tr>
            );
          })}

          {show ? (
            <tr>
              <td className="serial-num">{response.length + 1}</td>
              <td>
                <Form.Control
                  type="text"
                  className="shadow-none"
                  name="medicine"
                  value={Input.medicine}
                  onChange={handleOnInputChange}
                />
              </td>
              <td>
                <Form.Control
                  type="date"
                  className="shadow-none color-dark"
                  name="dosage"
                  style={{textAlign: 'center',minWidth:'140px'}}
                  value={Input.dosage}
                  onChange={handleOnInputChange}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  className="shadow-none color-dark"
                  name="duration"
                  value={Input.duration}
                  onChange={handleOnInputChange}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  className="shadow-none"
                  name="instructions"
                  value={Input.instructions}
                  onChange={handleOnInputChange}
                />
              </td>
              <td>
                <span onClick={handleAddNewTest}>
                  <FaCheckCircle
                    style={{ color: "#8bab7e", cursor: "pointer" }}
                  />
                </span>
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>
    </div>
  );
};

export default LabTable;
